import React, { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Step from '../../../../../../../features/components/Forms/StepForm/Step'
import MultiSelectBox from '../../../../../../../features/components/Form/MultiSelectBox'
import ErrorMessage from '../../../../../../../components/Form/ErrorMessage'

import { selectedDV360AdAccountSelector } from '../../../../../../../modules/selectors/adAccounts'

import { formatOptionsList } from '../../../../../../../features/formatters'

import { PIXELS } from '../../../../../LineItemForms/LineItemDv360Create/LineItemDv360CreateForm/LineItemDV360CreateMainForm/fields'

const stepFields = [PIXELS]

const PixelStep = ({ formik, handleStepChange }) => {
  const { t } = useTranslation()

  const selectedDV360AdAccount = useSelector(selectedDV360AdAccountSelector)

  const { dv360_floodlight_groups: dv360FloodlightGroups } = selectedDV360AdAccount

  const { values, setFieldValue, errors, touched } = formik

  const formattedPixels = useMemo(
    () =>
      formatOptionsList({
        list: dv360FloodlightGroups,
        labelName: 'name',
        valueName: 'id'
      }),
    [dv360FloodlightGroups]
  )

  const handleContinue = useCallback(() => {
    handleStepChange(stepFields)
  }, [handleStepChange])

  return (
    <Step stepTitle="Please select at least one pixel" handleContinue={handleContinue}>
      <MultiSelectBox
        placeholder={t('Select pixels')}
        options={formattedPixels}
        name={PIXELS}
        value={values[PIXELS]}
        isLoading={false}
        setFieldValue={setFieldValue}
        isSearchable={false}
      />
      {errors[PIXELS] && touched[PIXELS] && <ErrorMessage error={errors[PIXELS]} />}
    </Step>
  )
}

export default PixelStep
